// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"460cbc8b","322":"8517f812","467":"222407e2","584":"e5996b42","689":"512cdcf8","693":"7007adfa","744":"956ca063","836":"ac037739","929":"1ddca80d","954":"124e6908","969":"2469c78f"}[chunkId] + ".chunk.js";
};